export default __webpack_public_path__ + "static/media/marly.a0a59cec.JPG";